import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { Filters } from "./styles";
import Main from "../../../../layout/main/Main";
import { COLORS, Typo } from "../../../../layout/theme";
import DataTable from "../../../../common/data-table/DataTable";
import { useAuth } from "../../../../../contexts/authContext";
import { get_agent_configs_page } from "../../../../../api/endpoints/agents";

export default function AgentConversationList({ clientId }) {
	const navigate = useNavigate();
	const { userdata } = useAuth();
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [data, setData] = useState(null);
	const [state, setState] = useState("ACTIVE");
	const [key, setKey] = useState("null");

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Cliente</div>,
			dataIndex: "name",
			width: 300,
			render: (value, record) => (
				<Link
					to={`/admin/agentConversations/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="secondary" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</Link>
			),
		},
	];

	const fetch_data_agent_clients = async (page, search) => {
		const res = await get_agent_configs_page(search, state, page);
		setData(res);
	};

	useEffect(() => {
		fetch_data_agent_clients(1, clientId);
	}, [state]);

	return (
		<Main>
			<Main.Breadcrumb>
				<Main.BreadcrumbItem>
					{uri ? (
						<Link to={"/" + uri}>Configuración General</Link>
					) : (
						<Link to="/">Home</Link>
					)}
				</Main.BreadcrumbItem>
				<Main.BreadcrumbSeparator />
				<Main.ActiveBreadcrumbItem>
					Listado de clientes
				</Main.ActiveBreadcrumbItem>
			</Main.Breadcrumb>

			<Main.Body>
				<Filters></Filters>
				<DataTable
					data={data}
					fetch={fetch_data_agent_clients}
					columns={columns}
				/>
			</Main.Body>
		</Main>
	);
}
